import React, { Suspense, lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { intlGet } from './utils';


const Home = lazy(() => import('./pages/home'));
const Technology = lazy(() => import('./pages/technology'));

const Solution_jmFleet = lazy(() => import('./pages/solution/jmFleet'));
// const Solution_jmFleetDetail = lazy(() => import('./pages/solution/jmFleetDetail'));
// const Solution_jmAuto = lazy(() => import('./pages/solution/jmAuto'));
const Solution_passengerVeh = lazy(() => import('./pages/solution/passengerVeh'));
const Solution_commercialVeh = lazy(() => import('./pages/solution/commercialVeh'));
const Solution_ja = lazy(() => import('./pages/solution/ja'));

const News = lazy(() => import('./pages/news'));
const AboutUs_aboutUs = lazy(() => import('./pages/aboutUs/aboutUs'));
const AboutUs_joinUs = lazy(() => import('./pages/aboutUs/joinUs'));
const AboutUs_joinUs_more = lazy(() => import('./pages/aboutUs/joinUs/more'));
const AboutUs_contactUs = lazy(() => import('./pages/aboutUs/contactUs'));

// 文章类的全部路由到这个组件
const PostComponent = lazy(() => import('./components/post'));

export const menus: Menu = {
  '/home': {
    path: '/home',
    title: intlGet('Home'),
    component: Home,
  },
  '/technology': {
    path: '/technology',
    title: intlGet('Technologies'),
    component: Technology,
  },
  // 产品中心
  // '/product': {
  //   path: '/product',
  //   title: intlGet('Products'),
  //   exact: false,
  //   component: Product
    // children: {
    //   '/product/intelliDrive': {
    //     path: '/product/intelliDrive',
    //     title: intlGet('Intelligent Driving'),
    //     component: Product_intelliDrive,
    //   },
    //   '/product/application': {
    //     path: '/product/application',
    //     title: intlGet('Industrial Applications'),
    //     component: Product_application,
    //   },
    //   '/product/zhiYun': {
    //     path: '/product/zhiYun',
    //     title: intlGet('AutoCloud'),
    //     component: Product_zhiYun,
    //   },
    // }
  // },
  // 解决方案
  '/solution': {
    path: '/solution',
    title: intlGet('Solutions'),
    children: {
      // '/solution/passengerVeh': {
      //   path: '/solution/passengerVeh',
      //   title: intlGet('passengerVeh'),
      //   component: Solution_passengerVeh,
      // },
      '/solution/commercialVeh': {
        path: '/solution/commercialVeh',
        title: intlGet('commercialVeh'),
        component: Solution_commercialVeh,
      },
      // '/solution/ja': {
      //   path: '/solution/ja',
      //   title: intlGet('risk reduction'),
      //   component: Solution_ja,
      // },
    }
  },
  '/news': {
    path: '/news',
    title: intlGet('News'),
    component: News,
  },
  // 关于我们
  '/aboutUs': {
    path: '/aboutUs',
    title: intlGet('About Us'),
    children: {
      '/aboutUs/aboutUs': {
        path: '/aboutUs/aboutUs',
        title: intlGet('About Us'),
        component: AboutUs_aboutUs,
      },
      '/aboutUs/joinUs': {
        path: '/aboutUs/joinUs',
        title: intlGet('Join Us'),
        component: AboutUs_joinUs,
      },
      // '/aboutUs/contactUs': {
      //   path: '/aboutUs/contactUs',
      //   title: intlGet('Contact Us'),
      //   component: AboutUs_contactUs,
      // },
    }
  },
}

const routeArr: JSX.Element[] = [];

const renderMenu = (menus: Menu, res: JSX.Element[]) => {
  Object.keys(menus).forEach(x => {
    const {path, title, component, children, exact = true} = menus[x];
    // console.log('menus', path, title, exact);
    if(children && Object.keys(children).length){
      renderMenu(children, res);
    }else{
      res.push(
        <Route exact={exact} path={path} component={component} key={path} />
      )
    }
  })
}
renderMenu(menus, routeArr);
 

const Routes = () => {
  return (
      <Switch>
        {/* <Redirect exact path='/product' to='/product/intelliDrive' /> */}
        {/* <Route exact path={'/product/intelliDrive'} component={Product_intelliDrive} />
        <Route exact path={'/product/application'} component={Product_application} />
        <Route exact path={'/product/zhiYun'} component={Product_zhiYun} /> */}
        <Route exact path={'/news/:id'} component={PostComponent} />
        <Route exact path={'/solution/passengerVeh/:id'} component={Solution_passengerVeh} />
        <Route exact path={'/aboutUs/joinUs/more'} component={AboutUs_joinUs_more} />
        <Route exact path={'/aboutUs/joinUs/:id'} component={PostComponent} />
        {routeArr}
        <Redirect exact path='/' to='/home' />
        <Route
          render={function () {
            return <h1>404 Page</h1>;
          }}
        />
      </Switch>
  );

}

export default Routes;